export const BUILD_VERSION = '0aadbf306e32501cee715358b3a1f67320bf65af';
